const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString() : "—");

export default function AdminGifts({ gifts }) {
  return (
    <>
      <h2 className="font-serif-display text-2xl mt-12 mb-6">Gift Passes</h2>
      <div className="border border-white/10 overflow-x-auto" data-testid="admin-reader-gifts">
        <table className="w-full text-sm">
          <thead className="bg-[#121212] text-soft font-mono-ui text-[10px] uppercase tracking-[0.2em]">
            <tr>{["Code", "Bought by", "Purchased", "Amount", "Redeemed by"].map((h) => <th key={h} className="text-left px-5 py-3">{h}</th>)}</tr>
          </thead>
          <tbody>
            {gifts.length === 0 ? (
              <tr><td colSpan={5} className="px-5 py-8 text-center text-soft">No gift passes sold yet.</td></tr>
            ) : (
              gifts.map((g) => (
                <tr key={g.id} className="border-t border-white/5" data-testid={`admin-gift-row-${g.code}`}>
                  <td className="px-5 py-3 font-mono-ui text-xs">{g.code}</td>
                  <td className="px-5 py-3 text-soft">{g.from_name || g.payer_email || "—"}</td>
                  <td className="px-5 py-3 text-soft">{fmtDate(g.created_at)}</td>
                  <td className="px-5 py-3">${g.amount.toFixed(2)}</td>
                  <td className="px-5 py-3">
                    {g.redeemed_at ? <span className="text-[#4ade80]">{g.redeemed_email} · {fmtDate(g.redeemed_at)}</span> : <span className="text-soft">Not yet</span>}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
